import React, { useState } from 'react';
import AppWrap from "../../Wrapper/AppWrap";
import { client } from "../../sanity_client/client";
import "./Footer.scss";
import { MdAttachEmail } from "react-icons/md";
import { BsTelephoneInboundFill } from "react-icons/bs";
import { motion } from "framer-motion";

const Footer = () => {

    const [ formData, setFormData ] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [ formSubmitted, setFormSubmitted ] = useState(false);
    const [ loading, setLoading ] = useState(false);

    const handleChange = (e)=>{
        const { name, value } = e.target;
        setFormData({ ...formData, [name]:value })
    }

    const handleSubmit = () =>{
        setLoading(true)
        // create the sanity object
        const contactMessage = {
            _type: 'contact',
            name: formData.name,
            email: formData.email,
            message: formData.message
        }
        console.log(contactMessage)
        //push message to sanity
        client.create(contactMessage)
            .then(()=>{
                setLoading(false);
                setFormSubmitted(true);
            })
            .catch((err)=> console.log(err))
    }

    return (
        <div className="footer-section">
            <h2 className="head-text">Contact Me</h2>
            
            <div className="footer-content">
                <div className="footer-contact-cards">
                    <div className="footer-card">
                        <MdAttachEmail />
                        <a href="mailto:shasa.thuo@gmail.com" className="p-text">shasa.thuo@gmail.com</a>
                    </div>

                    <div className="footer-card">
                        <BsTelephoneInboundFill />
                        <a href="tel:+254711194477" className="p-text">+254711194477</a>
                    </div>
                </div>

                {formSubmitted
                    ?(
                        <div>
                            <h3 className="head-text">
                                Thank you for getting in touch!
                            </h3>
                        </div>)
                    :(
                        <div className="form-section">
                            <div className="form-section-input">
                                <motion.input 
                                    whileFocus={{ scale: 1.05 }}
                                    className="p-text"
                                    type = "text"
                                    placeholder = "Your Name"
                                    name = "name"
                                    value = {formData.name}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="form-section-input">
                                <motion.input
                                    whileFocus={{scale: 1.03}}
                                    className="p-text"
                                    type = "text"
                                    placeholder = "Your Email"
                                    name = "email"
                                    value = {formData.email}
                                    onChange={handleChange}
                                />
                            </div>

                            <div>
                                <motion.textarea 
                                    whileFocus={{scale: 1.03}}
                                    className="p-text"
                                    type = "text"
                                    placeholder = "Your Message"
                                    name = "message"
                                    value = {formData.message}
                                    onChange={handleChange}
                                />
                            </div>
                            <button className="p-text" onClick={handleSubmit}>
                                {!loading ? 'Send Message' : 'Sending...'}
                            </button>
                        </div>
                    )
                }

            </div>
        </div>
    )
}

export default AppWrap(Footer, "contact")